import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { logoutUserApi } from "../../redux/actions/users/usersData";
import { setProfileSliceData } from "../../redux/features/profile/profileSlice";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

// This component is integrated in app to auto-logout the user
const AppAutoLogout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let timer;
  const minutes = 60;

  // this function sets the timer that logs out the user after 10 secs
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // clears any pending timer.
      resetTimer();
      // Listener clean up. Removes the existing event listener from the window
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      // logs out user
      logoutAction();
    }, 60000 * minutes); // 60000ms = 1min. You can change the time.
  };

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  // when component mounts, it adds an event listeners to the window
  // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 10 secs of inactivity resets.
  // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
  const logoutAction = () => {
    dispatch(logoutUserApi())
      .then((e) => {
        if (e?.meta?.requestStatus === "fulfilled") {
          localStorage.removeItem("token");
          localStorage.removeItem("organization");
          dispatch(
            setProfileSliceData({ type: "userProfile", data: undefined })
          );
          navigate("/");
        }
      })
      .catch((err) => {});
  };

  return children;
};

export default AppAutoLogout;
